import React, { PureComponent, ReactNode } from "react";
import Modal from "react-awesome-modal";
import Loader from "react-loader";
import Switch from "react-switch";
import { toast } from "react-toastify";
import { SOCKET as socket } from "src/common/constants";
import {
  clearSessionData,
  currentBaseUrl,
  currentUser,
  isUserLoggedIn,
  currentUserId,
} from "src/common/services";
import CustomNavComponent from "src/components/CustomNav/CustomNav.Component";
import PLEXLoader from "src/components/PlexLoader/Loader";
import { Loader as LoaderWrapper } from "src/components/SimpleLoader/SimpleLoader.styles";
import VimeoPlayer from "src/components/VimeoPlayer/VimeoPlayer.Component";
import withServices from "src/HOCs/withServices";

import alertLevel from "../../../../assets/images/reportcentre/alert-summary.jpg";
import completion from "../../../../assets/images/reportcentre/completion.jpg";
import radar from "../../../../assets/images/reportcentre/executive-summary.jpg";
import pupils from "../../../../assets/images/reportcentre/pupils.jpg";
import reflections from "../../../../assets/images/reportcentre/reflections.jpg";
import teaching from "../../../../assets/images/reportcentre/teaching-learning.jpg";
import { Container } from "../../../Teachers/TeacherMenu.styles";
import { Grid, GridItem, ModalWrapper } from "./ReportCenter.styles";
import { decodeSocketMessage } from "src/common/utils";

interface Props {
  history: any;
  services: any;
}
interface State {
  videoOpen: boolean;
  currentVideo: string;
  assessments: any;
  currentUserType?: string;
  selectedAssessment?: string;
  cohorts: any;
  selectedCohort?: string;
  sid?: string;
  socketLoading: boolean;
  reportToDownload?: string;
  downloadModal: boolean;
  reportType: string;
  downloadCompleteModal: boolean;
  loading: boolean;
  regenerateReport: boolean;
  yearGroups: any;
  selectedYearGroup?: string;
}

const reports = [
  {
    user_type: "students",
    report: "executive",
    title: "Your executive summary",
    text: " An awesome summary report which will give you an instant snapshot of your school or a specific cohort's current 'state of the nation'",
    image: radar,
    color: "#acff24",
    video: "https://player.vimeo.com/video/668544382?h=412c6b791d",
  },
  {
    user_type: "students",
    report: "completion_status",
    title: "Your completion status",
    text: "A quick glance at how many learners have completed their assessments versus how manu are yet to begin their exciting Performance Learning Journey",
    image: completion,
    color: "#3ee9f7",
    video:
      "https://player.vimeo.com/video/668544348?h=35d8e3ccc9&badge=0&autopause=0&player_id=0&app_id=58479",
  },
  {
    user_type: "students",
    report: "alert_level",
    title: "Your Alert Level Summary",
    text: "A powerful report that enables you to receive (in raw form) all of your learner's alert levels, school or cohort wide at the touch of a button",
    image: alertLevel,
    color: "#ff7a03",
    video:
      "https://player.vimeo.com/video/668544301?h=01643d3c1e&badge=0&autopause=0&player_id=0&app_id=58479",
  },
  {
    user_type: "students",
    report: "getting_to_know",
    title: "Getting to know your pupils",
    text: "An insightful, easy-to-understand one-page report that will provide you everything you need to know about your learner's state of mind, skillset, and behaviour",
    image: pupils,
    color: "#ff0b0b",
    video:
      "https://player.vimeo.com/video/668544442?h=f1b2f6be8c&badge=0&autopause=0&player_id=0&app_id=58479",
  },
  {
    user_type: "students",
    report: "reflections",
    title: "Reflections & Actions for Pupils",
    text: "Share this report with your learners and empower them to reflect and take immediate action to fulfill their potential and get them the results they deserve",
    image: reflections,
    color: "#f143fc",
    video:
      "https://player.vimeo.com/video/668544572?h=e2779d3a82&badge=0&autopause=0&player_id=0&app_id=58479",
  },
  {
    user_type: "teachers",
    report: "teaching",
    title: "Improving teaching & learning",
    text: "An empowering one-page report for your teachers to use to help elevate their rapport with their learners while providing key insight to safeguard their mental health",
    image: teaching,
    color: "#9143fc",
    video:
      "https://player.vimeo.com/video/668544517?h=e6b594ce2d&badge=0&autopause=0&player_id=0&app_id=58479",
  },
  {
    user_type: "students",
    report: "full-suite",
    title: "Deep Dive Result Report for Staff",
    text: "A deep dive into the learner results of the Foresight assessment for staff, including the selected responses.",
    image: pupils,
    color: "#3ee9f7",
    video:
      "https://player.vimeo.com/video/1069203657?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
  },
];

export const pStyles = {
  font: "italic bold 20px Roboto Condensed",
  marginBottom: "32px",
  "text-transform": "uppercase",
};

class ReportCenter extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      videoOpen: false,
      currentVideo: "",
      currentUserType: "",
      assessments: [],
      selectedAssessment: undefined,
      cohorts: [],
      selectedCohort: undefined,
      sid: undefined,
      reportToDownload: undefined,
      socketLoading: false,
      downloadModal: false,
      reportType: "",
      downloadCompleteModal: false,
      loading: false,
      regenerateReport: false,
      yearGroups: [],
      selectedYearGroup: undefined,
    };

    this.onSelectUserType = this.onSelectUserType.bind(this);
    this.onSelectAssessment = this.onSelectAssessment.bind(this);
    this.downloadReport = this.downloadReport.bind(this);
    this.onSelectYearGroup = this.onSelectYearGroup.bind(this);
  }

  public async componentDidMount() {
    if (!isUserLoggedIn()) {
      this.props.history.push("/login");
    } else {
      // if (!socket.connected) {
      //   socket.connect();
      // }
      console.log("Mounting Report Center");
      socket.connect();
      socket.on("connect", this.onSocketConnect);

      socket.on("customEmit", (data) => this.onSetup(data));

      socket.on("customNotif", (data) => this.onMessage(data));

      socket.emit("customMsg", { evt: "init" });

      const resYeargroups =
        await this.props.services.institutionsAPI.getInstitutionYearGroups(
          currentUserId()
        );

      // remove null yeargroups

      resYeargroups.data.yeargroups = resYeargroups.data.year_groups.filter(
        (yeargroup) => yeargroup !== null
      );

      this.setState({ yearGroups: resYeargroups.data.yeargroups });
    }
  }

  public onSocketConnect = () => {
    console.log("connected");
  };

  public onMessage(socketMessage) {
    const dataObj = decodeSocketMessage(socketMessage);
    this.setState({ socketLoading: false });
    const link = dataObj.message.data.link;

    if (dataObj.message.status === "failed") {
      toast.error(
        "Ooops, the report could not be generated: " +
          dataObj.message.data.final_status
      );
      return;
    }

    window.open(link, "_blank");
  }

  public onSetup = (message) => {
    this.setState({ sid: message.id });
  };

  public onLogout = (arg) => {
    clearSessionData();
    this.props.history.push("/login");
  };

  public onProfile = () => {
    this.props.history.push(`${currentBaseUrl()}profilepage`);
  };

  public openVimeoModal = (video) => {
    this.setState({ videoOpen: true, currentVideo: video });
  };

  public closeVimeoModal = () => {
    this.setState({ videoOpen: false });
  };

  public closeDownloadCompleteModal = () => {
    this.setState({ downloadCompleteModal: false });
  };

  public toggleDownloadModal = () => {
    const { downloadModal } = this.state;
    this.setState({ downloadModal: !downloadModal });
  };

  public toggleRegenerate = () => {
    const { regenerateReport } = this.state;
    this.setState({ regenerateReport: !regenerateReport });
  };

  public async downloadReport() {
    this.setState({ socketLoading: true });

    const {
      reportType,
      selectedAssessment,
      selectedCohort,
      sid,
      regenerateReport,
      selectedYearGroup,
    } = this.state;

    if (!sid || sid === undefined) {
      alert(
        "There is an issue with the report generation, please reload the page and try again."
      );
      toast.error(
        "There is an issue with the report generation, please reload the page and try again."
      );
      this.setState({ socketLoading: false });
      return;
    }

    const { institutionsAPI } = this.props.services;

    const regenerate = regenerateReport ? "yes" : "no";

    let downloadRes;

    if (reportType === "executive") {
      downloadRes = await institutionsAPI.downloadExecutiveSummaryReport(
        selectedAssessment,
        selectedCohort,
        sid,
        regenerate,
        selectedYearGroup
      );
    }

    if (reportType === "alert_level") {
      downloadRes =
        await this.props.services.institutionsAPI.generateAssessmentCohortReport(
          currentUserId(),
          selectedAssessment,
          selectedCohort,
          sid,
          regenerate
        );
    }

    if (reportType === "getting_to_know") {
      // downloadRes = await institutionsAPI.genInstitutionAssessmentZip(
      //   currentUserId(),
      //   selectedCohort,
      //   selectedAssessment,
      //   this.state.sid
      // );
      downloadRes = await this.props.services.institutionsAPI.getSinglePageZip(
        currentUserId(),
        selectedAssessment,
        selectedCohort,
        sid,
        regenerate,
        selectedYearGroup
      );
    }

    if (reportType === "completion_status") {
      downloadRes = await institutionsAPI.genInstitutionAssessmentCSV(
        currentUserId(),
        selectedCohort,
        selectedAssessment,
        sid,
        regenerate,
        selectedYearGroup
      );
    }

    if (reportType === "teaching") {
      downloadRes = await institutionsAPI.downloadTeacherReport(
        selectedAssessment,
        selectedCohort,
        sid,
        regenerate
      );
    }

    if (reportType === "reflections") {
      downloadRes = await institutionsAPI.downloadToLearnerReport(
        selectedAssessment,
        selectedCohort,
        sid,
        regenerate,
        selectedYearGroup
      );
    }

    if (reportType === "full-suite") {
      downloadRes = await institutionsAPI.genInstitutionAssessmentZip(
        currentUserId(),
        selectedCohort,
        selectedAssessment,
        sid
      );
    }

    if (downloadRes.ok) {
      this.setState({
        downloadModal: false,
        downloadCompleteModal: true,
      });
    } else {
      toast.error("Ooops, the report could not be generated, try again.");
    }
  }

  public async onSelectUserType(userType, reportType) {
    this.setState({ loading: true });

    const {
      services: { currentUserID },
      services,
    } = this.props;

    const res = await services.institutionsAPI.getUserTypeAssessmentList(
      currentUserID,
      userType
    );

    if (res.ok) {
      if (!res.data.assessments.length) {
        toast.warn(`There are no ${userType} assessments at the moment`);
      }

      this.setState({
        assessments: res.data.assessments,
        currentUserType: userType,
        downloadModal: true,
        reportType,
        loading: false,
      });
    } else {
      toast.error(
        "Sorry, we are unable to fetch your assessments at this time!"
      );
    }
  }

  public async onSelectYearGroup(event) {
    console.log(event.target.value);
    const selectedYearGroup = event.target.value;

    this.setState({ selectedYearGroup });
  }

  public async onSelectAssessment(event) {
    const selectedAssessment = event.target.value;

    const res = await this.props.services.institutionsAPI.getCohortsList(
      currentUserId(),
      selectedAssessment
    );

    if (res.ok) {
      this.setState({ cohorts: res.data.cohorts, selectedAssessment });
    }
  }

  public onSelectAssessmentCohort = (e) => {
    if (!e.target.value.length) {
      return;
    }
    this.setState({ selectedCohort: e.target.value });
  };

  public renderDownloadCompleteModal = () => {
    return (
      <Modal
        visible={this.state.downloadCompleteModal}
        effect="fadeInDown"
        height="200"
        width="400"
      >
        <div className="exit-modal-container">
          <p className="exit-warning">
            Here are your reports. They will be downloaded directly from here
            for you.
          </p>
          <i
            style={{ fontSize: "48px", marginBottom: "20px" }}
            className="fa fa-check"
          />
          <div className="exit-warning-buttons">
            <button
              className="blue-button"
              onClick={this.closeDownloadCompleteModal}
            >
              Thank You
            </button>
          </div>
        </div>
      </Modal>
    );
  };

  public assessmentPicker() {
    const {
      assessments,
      // showAssessmentPicker,
      currentUserType,
      selectedCohort,
      selectedAssessment,
      cohorts,
    } = this.state;

    return (
      <div className="reports-wrapper">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
          className="reports-query"
        >
          {/* usertype options */}
          <div className="show-picker">
            <p style={pStyles}>
              We are exploring &nbsp;
              <span style={{ color: "#3ee9f7" }}>
                {currentUserType === "students" ? "learners" : "teachers"}
              </span>
            </p>
          </div>

          {/* assessment options */}
          <div>
            <span style={{ fontStyle: "italic", textAlign: "center" }}>
              Choose an assessment to explore{" "}
            </span>
            <select
              className="custom-select"
              onChange={this.onSelectAssessment}
              style={{ width: "300px", marginTop: "0.5em" }}
            >
              <option> -- </option>
              {assessments.map((assessment) => (
                <option
                  selected={assessment.id === +!selectedAssessment}
                  key={assessment.id}
                  value={assessment.id}
                >
                  {assessment.name}
                </option>
              ))}
            </select>
          </div>

          {/* Cohorts */}
          <div>
            <span style={{ fontStyle: "italic", textAlign: "center" }}>
              Choose a cohort &nbsp;{" "}
            </span>
            <select
              className="custom-select"
              onChange={this.onSelectAssessmentCohort}
              style={{ width: "300px", marginTop: ".5em" }}
            >
              <option value=""> -- </option>
              {cohorts.map((cohort) => (
                <option
                  selected={cohort.assessment === selectedCohort}
                  key={cohort.assessment}
                  value={cohort.assessment}
                >
                  {cohort.assessment}
                </option>
              ))}
            </select>
          </div>

          {/* yeargroups */}
          <div>
            <span style={{ fontStyle: "italic", textAlign: "center" }}>
              Choose a year group (Optional) &nbsp;{" "}
            </span>
            <select
              className="custom-select"
              onChange={this.onSelectYearGroup}
              style={{ width: "300px", marginTop: ".5em" }}
            >
              <option value=""> -- </option>
              {this.state.yearGroups.map((yeargroup) => (
                <option
                  selected={yeargroup === this.state.selectedYearGroup}
                  key={yeargroup}
                  value={yeargroup}
                >
                  {yeargroup}
                </option>
              ))}
            </select>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              justifyContent: "space-evenly",
            }}
          >
            <span>Regenerate Reports</span>
            <Switch
              checked={this.state.regenerateReport}
              onChange={this.toggleRegenerate}
              offColor="#ff0033"
              onColor="#75db00"
              offHandleColor="#fff"
              aria-labelledby="switch-label"
              checkedIcon={false}
              uncheckedIcon={false}
            />
          </div>

          <button
            onClick={this.downloadReport}
            style={{ marginTop: "1em", padding: ".5em 3em" }}
            className="green-button download-report"
          >
            Download Now
          </button>
        </div>
      </div>
    );
  }

  public render(): ReactNode {
    return (
      <Container>
        <Modal
          height="360"
          width="640"
          visible={this.state.videoOpen}
          effect="fadeInDown"
          onClickAway={this.closeVimeoModal}
        >
          <VimeoPlayer video={this.state.currentVideo} />
        </Modal>

        <Modal
          height="500"
          width="400"
          visible={this.state.downloadModal}
          effect="fadeInDown"
          onClickAway={this.toggleDownloadModal}
        >
          <ModalWrapper>
            <i
              className="fa fa-times-circle-o close-report-modal"
              aria-hidden="true"
              onClick={this.toggleDownloadModal}
            />
            {this.assessmentPicker()}
          </ModalWrapper>
        </Modal>

        {this.renderDownloadCompleteModal()}

        <CustomNavComponent
          {...this.props}
          logoutParent={this.onLogout}
          profileParent={this.onProfile}
        />

        <h1 style={{ fontSize: "40px" }} className="menu-heading">
          Welcome to the Report Center
        </h1>
        <h2
          style={{
            font: "bold italic 18px 'Roboto Condensed'",
            textTransform: "uppercase",
          }}
          className="report-subheading"
        >
          Take full advantage and gain access to all of your reports and
          insights
        </h2>

        <Grid>
          {reports.map((report, i) => (
            <GridItem
              highlightColor={report.color}
              backgroundImage={report.image}
              key={`report_center_${i}_${report.title}`}
            >
              <div className="bg-holder">
                <img src={report.image} alt="" />
              </div>

              <div className="grid-item-content">
                <div className="play-icon">
                  <i
                    className="fa fa-play-circle-o play-vid"
                    aria-hidden="true"
                    onClick={this.openVimeoModal.bind(this, report.video)}
                  />
                </div>
                <h3 className="report-title">{report.title}</h3>
                <p className="report-description">{report.text}</p>
                <button
                  onClick={this.onSelectUserType.bind(
                    this,
                    report.user_type,
                    report.report
                  )}
                  className="download-report"
                >
                  Download
                </button>
              </div>
            </GridItem>
          ))}
        </Grid>
        {this.state.socketLoading ? (
          <LoaderWrapper>
            <PLEXLoader width={150} height={100} loaderId={4} />
          </LoaderWrapper>
        ) : (
          ""
        )}
        <Loader color="#ff0033" loaded={!this.state.loading} />
      </Container>
    );
  }
}

export default withServices(ReportCenter);

// https://app.plex.coach/api/v1/institutions/14/2021_05/gencsv/20/?sid=5bb01f798c534aeba958fe09ead4e487



// WEBPACK FOOTER //
// ./src/pages/DataCenter/School/ReportCenter/ReportCenter.Component.tsx